// for add 3 dots in string
export const add3Dots = (source, size, showFullTitle) => {
    if (showFullTitle) return source;
    return (source && source.length > size) ? source.slice(0, size - 1) + "…" : source;
}
export const getFullNameWithMiddleName = (fname, mname, lname) => {
    return `${fname || ''} ${mname || ''} ${lname || ''}`
}
export const getName = (arg1, arg2) => {
    if (typeof arg1 === 'boolean' || arg2 !== undefined) {
        const flag = arg1;
        const data = arg2;

        if (flag) {
            return data?.displayName || '';
        }

        const firstName = data?.firstName || '';
        const lastNameChar = data?.lastName?.charAt(0)?.toUpperCase();
        return lastNameChar ? `${firstName} ${lastNameChar}.` : firstName;
    }

    const user = arg1;
    return user?.name || `${user?.firstName ? user?.firstName : ''} ${user?.lastName ? user?.lastName : ''}`;
};

export const getFullName = (a, b) => {
    if (a && typeof a === 'object') return `${a?.firstName || ''} ${a?.lastName || ''}`;
    return `${a || ''} ${b || ''}`;
};

// This function capitalizes the first letter of a given string

export function capitalizeFirstLetter(val = "") {
    val = String(val)?.toLowerCase();
    return val?.charAt(0)?.toUpperCase() + val?.slice(1);
}


export const spiltContact = (num) => {
    if (num?.length > 0) {
        return num.split('-')
    } else return ''
}
export const joinContact = (code, number) => `${code}-${number}`

export const get2Letter = (name = '') => {
    const array = name.split(' ');
    if (array.length < 2) return name.substring(0, 2)
    else return `${array[0].charAt(0)}${array[1].charAt(0)}`
}

// ===== migrated from pms/src/common/functions/common.jsx =====
function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

export const addDots = (source, size) => {
    return source.length > size ? source.slice(0, size - 1) + "…" : source;
}

export const  replaceKeysInString = (arr, direction, inputStr)=> {
    if (!Array.isArray(arr) || typeof inputStr !== 'string' || !['toId', 'toName'].includes(direction)) {
        throw new Error("Invalid input parameters");
    }

    // Create a map for fast lookup
    const lookup = new Map();
    arr.forEach(obj => {
        if (obj.name && (obj._id || obj.refCustomFieldId)) {
            if (direction === 'toId') {
                lookup.set(obj.name, (obj.refCustomFieldId || obj._id));
            } else if (direction === 'toName') {
                lookup.set((obj.refCustomFieldId || obj._id), obj.name);
            }
        }
    });

    let result = inputStr;
    lookup.forEach((value, key) => {
        const regex = new RegExp(`\\b${escapeRegExp(key)}\\b`, 'g');
        result = result.replace(regex, value);
    });

    return result;
};